/*
 *
 * File JS per animazione
 *
 */
// import gsap from "gsap";

import ScrollMagic from "scrollmagic";
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./animate-in.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const animateIn = () => {
    let controllerAnimateIn = new ScrollMagic.Controller();
    let fromBottom = document.querySelectorAll(".animate-from-bottom");
    let fromTop = document.querySelectorAll(".animate-from-top");
    let fade = document.querySelectorAll(".fade");
    ScrollTrigger.config({ ignoreMobileResize: true });
    let windowWidth = window.innerWidth;

    if (!fromBottom) {
        return;
    } else {
        fromBottom.forEach((el) => {
            let fromBottomOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : 50;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: fromBottomOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!fromTop) {
        return;
    } else {
        fromTop.forEach((el) => {
            let fromTopOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : 50;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: fromTopOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!fade) {
        return;
    } else {
        fade.forEach((el) => {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: "onEnter",
                reverse: false,
                offset: 80,
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (windowWidth > 499) {
        const allTBottom = gsap.utils.toArray(".t-bottom");
        allTBottom.forEach((tBottom) => {
            gsap.to(tBottom, {
                yPercent: 14,
                ease: "none",
                scrollTrigger: {
                    trigger: tBottom,
                    scrub: 1,
                },
            });
        });

        const allTTop = gsap.utils.toArray(".t-top");
        allTTop.forEach((tTop) => {
            gsap.to(tTop, {
                yPercent: -14,
                ease: "none",
                scrollTrigger: {
                    trigger: tTop,
                    scrub: 1,
                },
            });
        });
    } else {
        return;
    }
};

export default animateIn;

//--------------------------------------------------------------------//
